module.exports = __webpack_public_path__ + "img/07_shimizu_04.4b0de3c2.jpg";